export default __webpack_public_path__ + "static/media/404.ded87f5c.svg";